import { ReactNode } from "react";
import { TopNavigation } from "./TopNavigation";
import { Sidebar } from "./Sidebar";

type LayoutProps = {
  sidebar: ReactNode;
  children: ReactNode;
};

export const Layout = ({ sidebar, children }: LayoutProps) => (
  <div>
    <TopNavigation />
    <div className="pb-16 lg:flex lg:space-x-10 lg:space-y-10">
      <Sidebar>{sidebar}</Sidebar>
      <div className="flex-1 pr-10">{children}</div>
    </div>
  </div>
);
